import DeleteIcon from "@mui/icons-material/Delete";
import { Avatar, Box, Button, Stack, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  flexBetweenCenter,
  itemsCenter,
} from "../../utilities/commonStyles/commonStyles";
import {
  archiveStudentData,
  deleteStudentData,
  getSiblingRecords,
  unArchiveStudentData,
} from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";

export default function PersonalInformation({ data, archive }) {
  //   console.log({ data });
  const { setLoading } = useContext(AuthContext);
  const [siblingData, setSiblingData] = useState([]);

  const handleArchive = async () => {
    try {
      const confirm = window.confirm("Archive this student?");
      if (!confirm) {
        return;
      }
      setLoading(true);
      const res = await archiveStudentData(data);
      setLoading(false);
      console.log({ res });
      if (!res?.error) {
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUnArchive = async () => {
    try {
      const confirm = window.confirm("Un Archive this student?");
      if (!confirm) {
        return;
      }
      setLoading(true);
      const res = await unArchiveStudentData(data);
      setLoading(false);
      console.log({ res });
      if (!res?.error) {
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async () => {
    try {
      const confirm = window.confirm("Delete this student data?");
      if (!confirm) {
        return;
      }
      setLoading(true);
      const res = await deleteStudentData(data);
      setLoading(false);
      // console.log({ res });
      if (!res?.error) {
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSiblings = async () => {
    try {
      if (!data?.id) {
        return;
      }
      setLoading(true);
      const res = await getSiblingRecords(data);
      if (!res.error) {
        setSiblingData(res?.data);
      } else {
        window.alert(res.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    fetchSiblings();
  }, [data]);

  const navigate = useNavigate();

  return (
    <Box sx={{ width: "80%" }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        {/* <Button
          onClick={() => {
            if (archive) {
              handleUnArchive();
              return;
            }
            handleArchive();
          }}
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            mr: 2,
            color: "gray",
          }}
        >
          {archive ? "Un Archive" : "Archive"}
        </Button> */}
        <Button
          onClick={handleDelete}
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            mr: 2,
            color: "gray",
          }}
        >
          <DeleteIcon />
          Delete
        </Button>
        {!archive && (
          <Button
            onClick={() =>
              navigate("edit", {
                state: {
                  userData: data,
                },
              })
            }
            type="submit"
            variant="contained"
          >
            Edit
          </Button>
        )}
      </Box>
      <Box sx={{ display: "flex", mt: "20px", ...flexBetweenCenter }}>
        <Stack spacing={4} sx={{ width: "60%" }}>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              School Name:{" "}
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.school}
            </Typography>
          </Box>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              Address:
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.address}
            </Typography>
          </Box>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              Father Name:
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.pName}
            </Typography>
          </Box>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              Father Phone:
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.pPhone}
            </Typography>
          </Box>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              Mother Name:
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.mName}
            </Typography>
          </Box>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              Mother Phone:
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.mPhone}
            </Typography>
          </Box>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              Registered By:
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.registeredBy}
            </Typography>
          </Box>
          <Box sx={{ ...itemsCenter, gap: "20px" }}>
            <Typography
              sx={{
                width: "40%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#242424",
              }}
            >
              Car Plate:
            </Typography>
            <Typography
              sx={{
                width: "60%",
                fontSize: "18px",
                fontWeight: 500,
                color: "#5C5C5C",
              }}
            >
              {data?.carPlate}
            </Typography>
          </Box>
          {siblingData?.map((e, index) => (
            <Box sx={{ ...itemsCenter, gap: "20px" }}>
              <Typography
                sx={{
                  width: "40%",
                  fontSize: "18px",
                  fontWeight: 500,
                  color: "#242424",
                }}
              >
                Sibling {index + 1}:
              </Typography>
              <Typography
                onClick={() => {
                  navigate(`/student-info/${e.id}`, {
                    state: {
                      userData: e,
                    },
                    replace: true,
                  });
                }}
                sx={{
                  cursor: "pointer",
                  width: "60%",
                  fontSize: "18px",
                  fontWeight: 500,
                  color: "#5C5C5C",
                  textDecoration: "underline",
                }}
              >
                {e.name}
              </Typography>
            </Box>
          ))}
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#fff",
              padding: "10px",
              borderRadius: "10px",
              border: "1px solid #959595",
            }}
          >
            <img
              src={data?.qrCode}
              style={{ height: "100px", width: "100px" }}
            />
          </Box>
          <Avatar src={data?.pImage} sx={{ height: "100px", width: "100px" }} />
          <Avatar src={data?.mImage} sx={{ height: "100px", width: "100px" }} />
        </Box>
      </Box>
    </Box>
  );
}
